import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useDebouncedCallback } from 'use-debounce'

import { TOrderForm } from '../contexts/FormProvider'

const STORE_DEBOUNCE_MS = 1000

type TProps = {
  persistNote: (value: string) => void
}

/**
 * Hook for remembering the note field in the form.
 */
export const useRememberNote = ({ persistNote }: TProps) => {
  const { control } = useFormContext<TOrderForm>()

  // watched form note field
  const [note] = useWatch({
    control,
    name: [`note`],
  })

  // persist only after some delay in changes
  const debouncedPersist = useDebouncedCallback(persistNote, STORE_DEBOUNCE_MS)

  // connect the debounced persist function to the value changes
  React.useEffect(() => {
    debouncedPersist(note)
  }, [note, debouncedPersist])
}
